export const RENDER_TYPE = "questionnaire-v2" as const;
